import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import axios from "axios";
import { updateMessageUrl } from "../../../../redux/Slice/Inbox/InboxMessageSlice";

const SERVER_DOMAIN = process.env.REACT_APP_SERVER_DOMAIN || 'http://localhost:8000';

/**
 * Lazily resolves a SMB echo message's media URL on demand (download-button
 * click) via POST /api/messages/fetch-echo-media, shared by ImageViewer/
 * VideoBox/AudioBox/DocumentBox — previously each component duplicated this
 * exact fetch/guard/dispatch logic with only the console.error tag differing.
 */
export function useEchoMediaFetch(initialUrl, { contactId, messageId, tag }) {
  const dispatch = useDispatch();
  const [resolvedUrl, setResolvedUrl] = useState(initialUrl || null);
  const [isFetching, setIsFetching] = useState(false);

  useEffect(() => {
    if (initialUrl) setResolvedUrl(initialUrl);
  }, [initialUrl]);

  const handleFetch = async () => {
    if (isFetching || !contactId || !messageId) return;
    setIsFetching(true);
    try {
      const { data } = await axios.post(
        `${SERVER_DOMAIN}/api/messages/fetch-echo-media`,
        { contactId, messageId },
        { withCredentials: true }
      );
      if (data?.url) {
        setResolvedUrl(data.url);
        dispatch(updateMessageUrl({
          contactId,
          messageId,
          url: data.url,
          mediaFileSizeBytes: data.mediaFileSizeBytes || null,
        }));
      }
    } catch (err) {
      console.error(`[${tag}] fetch-echo-media failed:`, err.message);
    } finally {
      setIsFetching(false);
    }
  };

  return { resolvedUrl, setResolvedUrl, isFetching, handleFetch };
}
